import { PlusIcon } from "@heroicons/react/24/outline";

interface HoveredAddButtonHintProps {
  hoverClass: string;
  className: string;
}

export const HoveredAddButtonHint: React.FC<HoveredAddButtonHintProps> = ({ hoverClass, className }) => {
  return (
    <div
      className={`pointer-events-none h-0 w-full pr-6 flex flex-row justify-center absolute z-[-1] ${className}`}
      style={{ pageBreakInside: "avoid", contain: "layout" }}
    >
      <PlusIcon
        className={`h-6 w-6 bg-green-600 hover:bg-green-700 text-white transition-opacity duration-200 opacity-0 rounded-xl ${hoverClass} pointer-events-none`}
      />
    </div>
  );
};
